var map = {
	"./address_image.svg": 128,
	"./amazon.svg": 129,
	"./animated_ashutosh.png": 130,
	"./animated_logo.svg": 131,
	"./blogs_image.svg": 132,
	"./cloud_infrastructure.svg": 133,
	"./codeInLogo.png": 134,
	"./contactMail.png": 135,
	"./coursera_logo.png": 136,
	"./cropped-sphs.jpeg": 137,
	"./data_science.svg": 138,
	"./deeplearning_ai_logo.png": 139,
	"./delhivery_logo.png": 140,
	"./developerActivity.svg": 141,
	"./dsc_logo.png": 142,
	"./education.svg": 143,
	"./experience.svg": 144,
	"./ezage.jpeg": 145,
	"./feelingProud.svg": 146,
	"./freecopy_logo.png": 147,
	"./fullstack.svg": 148,
	"./gcp_logo.png": 149,
	"./github_logo.png": 150,
	"./googleAssistant.jpg": 151,
	"./googleAssistant.svg": 152,
	"./google_logo.png": 153,
	"./ibm_logo.png": 154,
	"./iiitk_logo.png": 155,
	"./intel_logo.jpg": 156,
	"./iu_logo.png": 157,
	"./jsFramework.svg": 158,
	"./julogo.png": 159,
	"./legato_logo.png": 160,
	"./manOnTable.svg": 161,
	"./microsoft_logo.png": 162,
	"./mozilla_logo.png": 163,
	"./muffito_logo.png": 164,
	"./nextuLogo.jpg": 165,
	"./nptel_logo.png": 166,
	"./pegnamindiapvtltd_logo.jpeg": 167,
	"./portfolio.gif": 168,
	"./programmer.svg": 169,
	"./projects_image.svg": 170,
	"./pwa.png": 171,
	"./pwclogo.jpg": 172,
	"./saayaHealthLogo.png": 173,
	"./sainikProfile.JPG": 23,
	"./sainikdp.jpeg": 54,
	"./sainikpic.JPG": 174,
	"./sphs (2).jpeg": 175,
	"./sphs.jpeg": 176,
	"./stanford_logo.png": 177,
	"./talksCardBack.svg": 178,
	"./talksCardBackAlt.svg": 179,
	"./tiktok_logo.png": 180,
	"./ucbark.png": 181,
	"./ui_ux_design.svg": 182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44;